import { BackofficeOrganizationsActionType, BackofficeOrganizationsActions } from './organizations';
import { BackofficeProjectsActionType, BackofficeProjectsActions } from './projects';
import { BackofficeTranslationsActionType, BackofficeTranslationsActions } from './translations';
import { BackofficeUsersActionType, BackofficeUsersActions } from './users';

export const BackofficeConstants = {
  ...BackofficeUsersActionType,
  ...BackofficeOrganizationsActionType,
  ...BackofficeProjectsActionType,
  ...BackofficeTranslationsActionType,
};

export type BackofficeActions =
  | BackofficeOrganizationsActions
  | BackofficeProjectsActions
  | BackofficeTranslationsActions
  | BackofficeUsersActions;
